<template>
  <footer class="footer">
    <div class="wrapper cf">
      <div class="footer__copy">&copy; Кандинский Н.А., 2019 - {{this.thisYear}} гг.</div>
      <div class="footer__technologies">
        <span class="footer__technologies-name">Используемые технологии:</span>
        HTML5, СSS3 + SCSS, Gulp, Vue.js
      </div>
    </div>
    <scroll-to-top/>
  </footer>
</template>

<script>
import ScrollToTop from './ScrollToTop'

export default {
  name: "Footer",
  components: { ScrollToTop },
  data () {
    return {
      thisYear: 0,
    }
  },
  methods: {
    funcYear: function () {
      this.thisYear = new Date().getFullYear()
    }
  },
  mounted () {
    this.funcYear()
  }
}
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  height: 75px;
  margin: -75px 0 0;
  background: $bg-color;

  @media screen and (min-width: 768px){
    height: 50px;
    margin: -50px 0 0;
  }

  &:before {
    content: '';
    position: absolute;
    top: -2px;
    left: 0;
    width: 100%;
    height: 1px;
    background: $bg-color;
  }

  &__copy {
    padding: 10px 0 0;
    @include font(14px, 18px, #ffffff);

    @media screen and (min-width: 768px){
      float: left;
      padding: 0;
      @include font(14px, 50px, #ffffff);
    }
  }

  &__technologies {
    padding: 5px 0 0;
    @include font(14px, 18px, #ffffff);

    @media screen and (min-width: 768px){
      float: right;
      padding: 8px 0 0;
    }

    &-name {
      display: block;
      font-family: Roboto-Bold, sans-serif;
    }
  }
}
</style>